import { CollaboratorService } from './../../../../rest/api/collaborator.service';
import { Component, OnInit, Input} from '@angular/core';
import { AuthService } from './/../../../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HelperService } from './/../../../../services/helper.service';

@Component({
  selector: 'app-collaborator-edit',
  templateUrl: './collaborator-edit.component.html',
  styleUrls: ['./collaborator-edit.component.scss']
})
export class CollaboratorEditComponent implements OnInit {
  @Input() collaboratorsData;
  accessToken: any;
  langShortCode: any;
  loader = true;
  collaboratorId: any;
  collaboratorDetailData: any;
  isSubmitting = false;
  isSubmitted = false;
  errors = [];
  successMsg: string;
  errorMsg: string;
  collaboratorDetailForm: FormGroup;

  showPermission = false;
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    public fb: FormBuilder,
    public router: Router,
    public helperService: HelperService,
    public collaboratorService: CollaboratorService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.collaboratorId = params.id;
      if (!params.id) {
        this.router.navigate(['/']);
      }
      this.getCollaboratorDetail(this.collaboratorId);
    });
    this.collaboratorDetailFormInit();
    this.setAdminUserTypeValidators();
  }

  getCollaboratorDetail(id) {
    this.collaboratorService.getCollaboratorDetail({
      Authorization: this.accessToken,
      id: id
    }).subscribe((response: any) => {
      this.collaboratorDetailData = response && response.data ? response.data : undefined;
      this.resetForm();
      this.loader = false;
    }, err => {
      this.collaboratorDetailData = [];
      this.loader = false;
    });
  }

  collaboratorDetailFormInit() {
    this.collaboratorDetailForm = this.fb.group({
      role: [''],
      invoice_permission: [false],
      billing_permission: [false],
      email_permission: [false]
    });
  }

  submit(value) {
    if (!this.collaboratorDetailForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    this.collaboratorDetail(data, this.collaboratorId);
  }

  resetErrors() {
    this.successMsg = undefined;
    this.errorMsg = undefined;
    this.errors = [];
  }

  collaboratorDetail(data, id) {
    let formData;
    formData = {
      role: data.role
    };
    if (data.role === 'admin') {
      formData.invoice_permission = data.invoice_permission ? true : false;
      formData.billing_permission = data.billing_permission ? true : false;
      formData.email_permission = data.email_permission ? true : false;
    }

    data = this.helperService.updateJsonFormat(formData);
    this.collaboratorService.updateRole({
      Authorization: this.accessToken,
      id: id,
      body: data
    }).subscribe((response: any) => {
      this.collaboratorDetailData = response && response.data ? response.data : undefined;
      this.resetForm();
      this.successMsg = 'Role has been updated successfully';
      setTimeout(() => {
        this.resetErrors();
      }, 5000);
    }, err => {
      this.handleErrors(err);
    });
  }

  setAdminUserTypeValidators() {
    const invoicePermission = this.collaboratorDetailForm.get('invoice_permission');
    const billingPermission = this.collaboratorDetailForm.get('billing_permission');
    const emailPermission = this.collaboratorDetailForm.get('email_permission');

    this.collaboratorDetailForm.get('role').valueChanges
      .subscribe(role => {
        if (role === 'admin') {
          this.showPermission = true;
          invoicePermission.enable();
          billingPermission.enable();
          emailPermission.enable();
        } else {
          this.showPermission = false;
          invoicePermission.disable();
          billingPermission.disable();
          emailPermission.disable();
        }
        invoicePermission.updateValueAndValidity();
        billingPermission.updateValueAndValidity();
        emailPermission.updateValueAndValidity();
      });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.collaboratorDetailForm.reset({
      role: this.collaboratorDetailData.role,
      invoice_permission: this.collaboratorDetailData.invoice_permission,
      billing_permission: this.collaboratorDetailData.billing_permission,
      email_permission: this.collaboratorDetailData.email_permission,
    });
    this.setAdminUserTypeValidators();
  }

  handleErrors(err) {
    if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errors = err.error.errors;
    } else if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'Collaborators has been already added';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

}
